import apiHttpClient from "./ApiHttpService";
import Vue from "vue";

export default class WorkDayService {
  getWorkDays(startDate, endDate) {
    return apiHttpClient.get(
      `trs/mobile/WorkDay/getWorkDays?startDate=${startDate}&endDate=${endDate}`
    );
  }
  getWorkDay(workDate) {
    return apiHttpClient.get(`trs/mobile/WorkDay/getWorkDay/${workDate}`);
  }
  closeWorkDay(closeWorkdayModel) {
    return apiHttpClient.put(`trs/mobile/WorkDay/closeWorkDay`, closeWorkdayModel);
  }
  openWorkDay(workdayId) {
    return apiHttpClient.put(`trs/mobile/WorkDay/openWorkDay/${workdayId}`, {});
  }
  createWorkDays(workDates, dayType, clockedHours) {
    return apiHttpClient.post(`trs/mobile/WorkDay/createWorkDays`, {
      workDates: workDates,
      dayType: dayType,
      clockedHours: clockedHours,
    });
  }
  createWorkDay(workDate) {
    return apiHttpClient.post(`trs/mobile/WorkDay/createWorkDay/${workDate}`);
  }
  deleteWorkDay(workdayId) {
    return apiHttpClient.delete(
      `trs/mobile/WorkDay/deleteWorkDay/${workdayId}`
    );
  }
  getCardAccess(employeeId, workDate) {
    return apiHttpClient.get(`trs/mobile/WorkDay/getCardAccess?employeeId=${employeeId}&workDate=${workDate}`);
  }
  closeWorkdayError() {
      Vue.prototype.$toast.add({
        severity: "warn",
        summary:
          "No travel hours found, please add travel time to and from the site.",
        life: 3000,
        closable: false,
      });
  }
  getEmployeeContractFormat() {
    return apiHttpClient.get(`trs/mobile/WorkDay/getEmployeeContractFormat`);
  }
  splitWorkdayTravelTasks(splitModel) {
    return apiHttpClient.post(
      "trs/mobile/WorkDay/splitWorkdayTravelTask",
      splitModel
    );
  }
}
